
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from 'ant-design-vue';
import Client from '@/models/Client';
import { Action } from 'vuex-class';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { PopupEvents } from '@/enums/global/PopupEvents';
import { isRealNumber } from '@/helpers/OfferHistoryTableHelper';

@Component({
    name: 'CreateOrderButton',
    components: { Button },
})
export default class CreateOrderButton extends Vue {
    @Action('projectLoadingState/updateAreOffersLoading')
    private updateAreOffersLoading!: (newState: boolean) => void;

    @Prop({ default: false }) private offerHasErrors!: boolean;
    @Prop({ default: true }) private showIcon!: boolean;
    @Prop({ default: null }) private selectedOfferId!: string;
    @Prop({ default: null }) private client!: Client | null;
    @Prop({ default: false }) private offerPrice!: number;
    @Prop({ required: false, default: false }) private shouldGiveDiscount!: boolean;

    private async openConfirmModal() {
        if (!isRealNumber(this.offerPrice)) {
            this.$notification.error({
                message: this.$t('Greška') as string,
                description: this.$t('Offer price must be defined before making an order.') as string,
            });

            return;
        }

        EventBus.$emit(EventBusEvents.onOpenPdfPreviewOrderPopup, {
            popupEvent: PopupEvents.openPdfPreviewOrderPopup,
            data: {
                selectedOfferId: this.selectedOfferId,
                client: this.client,
                shouldGiveDiscount: this.shouldGiveDiscount,
            },
        });
    }
}
